export default __webpack_public_path__ + "static/media/layers.5e0f5b71.svg";